var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfilePicturesIcon1(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_1632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0910645 3.57436V0H4.45212V1.1111H1.44453V3.57436H0.0910645ZM18.5558 0H22.9048V3.57661H21.5513V1.1111H18.5558V0ZM22.9048 14.3243V17.896H18.5661V16.7849H21.5513V14.3243H22.9048ZM4.44355 17.896H0.0910645V14.3242H1.44453V16.7849H4.44355V17.896Z",
    fill: "#605BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5602 18.7256C13.0318 19.1595 12.3025 19.4287 11.5 19.4287C10.6975 19.4287 9.96831 19.1595 9.43984 18.7256C9.12935 18.4707 8.88805 18.1589 8.74179 17.8115C5.88986 18.3446 3.72623 19.2214 2.26605 20.4416C0.84733 21.6272 0.0872479 23.1468 0 25H23C22.9127 23.1468 22.1527 21.6272 20.734 20.4416C19.2738 19.2214 17.1101 18.3446 14.2582 17.8115C14.112 18.1589 13.8707 18.4707 13.5602 18.7256Z",
    fill: "#605BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05284 6.57092C4.95393 6.02771 4.93025 5.39754 5.2031 4.88403C5.57373 4.18655 6.48921 3.87362 7.35718 3.77679C7.43094 3.30158 7.68264 2.90313 8.06254 2.58034C8.64918 2.02179 9.57105 1.7467 10.6394 1.62323C12.9176 1.36013 15.6077 1.96297 17.2901 3.21732C18.6458 4.22802 19.4312 5.71807 18.9436 7.69903C18.8443 8.14056 18.4488 8.92945 18.4059 9.20039C17.9681 11.8679 17.0986 13.6778 15.7975 14.63C14.569 15.5295 14.1477 16.451 12.1441 16.451C10.2812 16.451 9.73845 15.4689 8.59221 14.6302C7.29101 13.678 6.42155 11.868 5.9837 9.20039C5.89336 8.63019 5.19629 7.50946 5.05284 6.57092ZM17.5429 8.65978C15.8711 7.52809 14.4193 7.72008 12.7612 7.73375C11.3086 7.74574 9.91631 7.75728 8.74008 6.8903L8.29457 6.56186C8.11123 7.2936 8.02945 7.45497 7.41823 8.08699C7.18465 8.32846 7.17103 8.35533 6.82498 8.65857C6.87718 8.7727 6.92495 8.88614 6.96112 8.99698C7.50456 10.662 7.49094 12.708 9.26757 14.0081C9.58523 14.2406 9.87156 14.4922 10.1634 14.7456C10.3752 14.9296 10.5963 15.1209 10.8411 15.2754C11.2446 15.5301 11.6364 15.6177 12.1441 15.6177C12.6865 15.6177 13.1283 15.5463 13.5615 15.2703C13.7971 15.1202 14.0101 14.9331 14.2142 14.755C14.5094 14.4974 14.7998 14.2439 15.1221 14.0081C16.6062 12.9216 17.1574 10.563 17.4151 8.99698C17.4247 8.93845 17.4776 8.80932 17.5429 8.65978Z",
    fill: "url(#paint0_linear_186_1632)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_186_1632",
    x1: 12.0367,
    y1: 1.5625,
    x2: 12.0367,
    y2: 16.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#605BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C88FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_1632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 25,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicturesIcon1);
export default __webpack_public_path__ + "static/media/ProfilePicturesIcon1.d85f474d583bad072fbbaddebd8566e4.svg";
export { ForwardRef as ReactComponent };